import type { RefObject } from 'react';

import { useEffect } from 'react';

import type { EditorJsData } from '#pages/document/editorjs-types';

export function useSyncEditorValueFromProp({
  editorRef,
  persistChainRef,
  latestValueRef,
  value,
}: {
  editorRef: RefObject<any | null>;
  persistChainRef: RefObject<Promise<unknown>>;
  latestValueRef: RefObject<EditorJsData | null>;
  value?: EditorJsData | null;
}): void {
  useEffect(() => {
    if (!editorRef.current) return;
    persistChainRef.current = Promise.resolve();
    latestValueRef.current = value ?? { blocks: [] };
    void editorRef.current.isReady
      .then(() =>
        editorRef.current.render(
          (latestValueRef.current as any) ?? { blocks: [] },
        ),
      )
      .catch(() => {});
  }, [value]);
}
